/* Kashira PDP behaviours: the sticky mobile ATC bar, buy-column price
   mirroring, and small buy-box helpers that need a script. */

/* Sticky mobile add-to-cart: shows the bar once the main buy buttons
   scroll out of view; the bar's button submits the main product form. */
(() => {
  const bar = document.querySelector('.kashira-sticky-atc');
  if (!bar) return;

  const buyButtons = document.querySelector('.product-form__buttons');
  if (!buyButtons || !('IntersectionObserver' in window)) return;

  // Show once the in-flow ATC scrolls above the viewport; hide again when the
  // footer enters view, the cart drawer is open, or a field has focus (spec 03).
  let atcGone = false;
  let footerInView = false;

  const update = () => {
    const drawerOpen = document.querySelector('cart-drawer')?.classList.contains('active');
    const typing = ['INPUT', 'TEXTAREA', 'SELECT'].includes(document.activeElement?.tagName);
    bar.classList.toggle('is-visible', atcGone && !footerInView && !drawerOpen && !typing);
  };

  new IntersectionObserver(
    ([entry]) => {
      atcGone = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      update();
    },
    { threshold: 0 }
  ).observe(buyButtons);

  const footer = document.querySelector('.footer');
  if (footer) {
    new IntersectionObserver(
      ([entry]) => {
        footerInView = entry.isIntersecting;
        update();
      },
      { threshold: 0 }
    ).observe(footer);
  }

  const drawer = document.querySelector('cart-drawer');
  if (drawer) new MutationObserver(update).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  document.addEventListener('focusin', update);
  document.addEventListener('focusout', () => setTimeout(update, 50));

  // Keep disabled state in sync with the main submit (sold out / unavailable)
  const mainSubmit = document.querySelector('.product-form__submit');
  const stickyBtn = bar.querySelector('button');
  if (mainSubmit && stickyBtn) {
    const sync = () => {
      stickyBtn.disabled = mainSubmit.disabled;
      const label = mainSubmit.querySelector('span');
      const stickyLabel = stickyBtn.querySelector('span');
      if (label && stickyLabel) stickyLabel.textContent = label.textContent;
    };
    sync();
    new MutationObserver(sync).observe(mainSubmit, { attributes: true, childList: true, subtree: true });
  }

  // The bar sits outside <product-info>, so Dawn's variant re-render never
  // reaches it. Mirror the buy-column price (and the media it switched to)
  // whenever that block changes, so the bar can never quote a stale price.
  const priceSource = document.querySelector('product-info [id^="price-"]');
  const stickyPrice = bar.querySelector('.kashira-sticky-atc__price');
  const stickyCompare = bar.querySelector('.kashira-sticky-atc__compare');
  // The in-flow ATC quotes its price in the label ("Add to cart — ₹24,850",
  // design 03 L296); it lives outside the price block, so mirror it here too.
  const atcPriceSuffix = document.querySelector('.product-form__submit .kashira-atc-price');
  if (priceSource && stickyPrice) {
    const stickyThumb = bar.querySelector('.kashira-sticky-atc__thumb img');
    const activeMedia = () =>
      document.querySelector('media-gallery li.product__media-item.is-active') ||
      document.querySelector('media-gallery li.product__media-item');
    let mediaId = activeMedia()?.dataset.mediaId;

    const currentPrice = () => {
      const price = priceSource.querySelector('.price');
      if (!price) return '';
      const onSale = price.classList.contains('price--on-sale');
      const item = price.querySelector(
        onSale ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular'
      );
      return item ? item.textContent.trim() : '';
    };

    const currentCompare = () => {
      const price = priceSource.querySelector('.price');
      if (!price || !price.classList.contains('price--on-sale')) return '';
      const item = price.querySelector('.price__sale s.price-item--regular');
      return item ? item.textContent.trim() : '';
    };

    const syncPrice = () => {
      const amount = currentPrice();
      if (amount) stickyPrice.textContent = amount;
      // Dawn hides the price block for an unavailable variant combination.
      stickyPrice.classList.toggle('hidden', !amount || priceSource.classList.contains('hidden'));
      if (stickyCompare) {
        const compare = currentCompare();
        if (compare) stickyCompare.textContent = compare;
        stickyCompare.classList.toggle('hidden', !compare);
      }
      // NBSP, not a plain space: a leading space at a flex-item boundary
      // collapses and the dash would abut the label.
      if (atcPriceSuffix && amount) atcPriceSuffix.textContent = ` — ${amount}`;

      const item = activeMedia();
      if (!stickyThumb || !item || item.dataset.mediaId === mediaId) return;
      mediaId = item.dataset.mediaId;
      // Reuse the candidate the gallery already downloaded — no extra request.
      const source = item.querySelector('img');
      const url = source?.currentSrc || source?.src;
      if (!url) return;
      stickyThumb.removeAttribute('srcset');
      stickyThumb.src = url;
    };

    syncPrice();
    new MutationObserver(syncPrice).observe(priceSource, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true,
    });
  }
})();
